import z from "zod";

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, { message: "Email ID is required." })
    .email({ message: "Invalid email address." }),
  otp: z.string().length(6, { message: "Invalid OTP." }),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
